import React from 'react';
import { useDevice } from '@/hooks';
import TicketBookingDesktop from '@/features/booking/components/desktop/TicketBookingDesktop';
import TicketBookingMobile from '@/features/booking/components/mobile/TicketBookingMobile';

const TicketBookingPage: React.FC = () => {
  const device = useDevice();

  if (device === 'mobile') {
    return <TicketBookingMobile />;
  }

  return <TicketBookingDesktop />;
};

export default TicketBookingPage;
